import axios from "axios";

// Create a base API instance
const api = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "" // Empty base URL for production (relative paths)
      : "http://127.0.0.1:5000", // Development server
  headers: {
    "Content-Type": "application/json",
  },
});

// API service functions
export const askQuestion = async (question) => {
  try {
    const response = await api.post("/ask", { question });
    return response.data;
  } catch (error) {
    console.error("Error asking question:", error);
    throw error;
  }
};

export const getResume = async () => {
  try {
    const response = await api.get("/download-resume");
    return response.data;
  } catch (error) {
    console.error("Error fetching resume:", error);
    throw error;
  }
};

export default api;
